var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.2495C4.44384 17.2495 0.750244 13.5559 0.750244 8.99976C0.750244 4.4436 4.44384 0.75 9 0.75C13.5562 0.75 17.2498 4.4436 17.2498 8.99976C17.2498 13.5559 13.5562 17.2495 9 17.2495ZM9 15.7498C12.728 15.7498 15.75 12.7277 15.75 8.99976C15.75 5.27178 12.728 2.24976 9 2.24976C5.27202 2.24976 2.25 5.27178 2.25 8.99976C2.25 12.7277 5.27202 15.7498 9 15.7498ZM9 9.28596L11.5853 10.579C11.9559 10.7639 12.1064 11.2146 11.9207 11.5852C11.7358 11.9557 11.2851 12.1062 10.9146 11.9206L7.91433 10.4208C7.6605 10.2935 7.50019 10.0341 7.50019 9.75001V5.25002C7.50019 4.83587 7.83558 4.49978 8.24973 4.49978C8.66387 4.49978 8.99997 4.83587 8.99997 5.25002L9 9.28596Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b37f070ffa40b54d814962a18f6322a5.svg";
export { ForwardRef as ReactComponent };